// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { ReactComponent as LogoText } from 'images/lw-text-logo.svg';
import useLogout from 'modules/oidc/useLogout';
import { usePollPendingNewAccountDetails } from 'modules/queries/account/useDetails';
import { Link as RouterLink } from 'react-router-dom';
import accountStatuses from 'utility/constants/accountStatuses';

const NavAction = () => {
	const { data: accountDetails, isLoading } = usePollPendingNewAccountDetails({
		alsowith: ['accountContact'],
	});

	const isNewAccount =
		accountDetails?.account_status === accountStatuses.PENDING_NEW;

	if (isLoading) {
		return (
			<Skeleton variant="rounded" sx={{ height: '40px', width: '170px' }} />
		);
	}

	return (
		<Button
			loading={isNewAccount}
			component={RouterLink}
			// @ts-expect-error
			to="/"
		>
			{!isNewAccount ? (
				<>
					<Typography sx={{ display: { xs: 'none', md: 'flex' } }}>
						Go to your dashboard
					</Typography>
					<Typography sx={{ display: { xs: 'flex', md: 'none' } }}>
						Dashboard
					</Typography>
				</>
			) : (
				<Typography>Setting up account</Typography>
			)}
		</Button>
	);
};

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/undercurrent/Button').ButtonProps} [props.logoutButtonProps]
 */
const OrderConfirmation = ({ logoutButtonProps }) => {
	const logout = useLogout();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<LogoText />
			<Stack direction="row" alignItems="center" gap={{ xs: 100, md: 200 }}>
				<NavAction />
				<Button variant="link" onClick={logout} {...logoutButtonProps}>
					Logout
				</Button>
			</Stack>
		</Box>
	);
};

export default OrderConfirmation;
